import { useContext } from "react";
import { ChatbotDataContext } from "../context/ChatbotDataContext.js";
import { ChatMessagesContext } from "../context/ChatMessagesContext.js";
import { LoadingStateContext } from "../context/LoadingStateContext.js";
import { submitChatMessages } from "../submitChatMessages.js";
import { useChatUIContext } from "./useChatUIContext.js";
const useHandleLinkClick = ()=>{
    const { submitChatMessagesPayload, setStreamingText, setErrorMessage, setIsDisablingInputValue, fetchRequestOptions, handleMarkerResponse, markerComponents } = useContext(ChatbotDataContext);
    const { setChatMessages, chatMessages } = useContext(ChatMessagesContext);
    const { setLoadingStatus, setLoadingStatusMessage, setLoadingHotelSkeleton } = useContext(LoadingStateContext);
    const { setOpenErrorComponent } = useChatUIContext();
    const handleLinkClick = (message)=>{
        const date = new Date();
        const newUserMessage = {
            role: 'user',
            content: message,
            date: date
        };
        const newMessages = [
            ...chatMessages,
            newUserMessage
        ];
        setChatMessages(newMessages);
        const newSubmitChatMessagesPayload = {
            ...submitChatMessagesPayload,
            prompts: [
                ...submitChatMessagesPayload?.prompts || [],
                newUserMessage
            ]
        };
        submitChatMessages({
            chatMessages: newMessages,
            handleMarkerResponse,
            markerComponents,
            requestOptions: fetchRequestOptions,
            setChatMessages,
            setErrorMessage,
            setIsDisablingInputValue,
            setLoadingStatus,
            setLoadingStatusMessage,
            setLoadingHotelSkeleton,
            setOpenErrorComponent,
            setStreamingText,
            submitChatMessagesPayload: newSubmitChatMessagesPayload
        });
    };
    return {
        handleLinkClick
    };
};
export { useHandleLinkClick };
